<template>
  <div class="booking">
    <div class="booking-card" :class="{hiddenUp:isSuess}">
      <div class="title">預約時段</div>
      <div class="dec-box">
        <span class="dec"></span>
        <span class="dec"></span>
        <span class="dec"></span>
      </div>
      <div class="input-row">
        <span class="title-o">姓名</span>
        <input type="text" class="input" v-model="bookingInfo.name">
      </div>
      <div class="input-row">
        <span class="title-o">電話</span>
        <input type="number" class="input" v-model="bookingInfo.tel">
      </div>
      <div class="input-row">
        <span class="title-o">預約起迄</span>
        <VueHotelDatepicker
          :fromText="'從'" :toText="'到'"
          :resetText="'重設'" :confirmText="'確認'"
          :weekList="['日', '一', '二', '三', '四', '五', '六' ]"
          :monthList="['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']"
          :disabledDates="disabledDates"
          @confirm="confirm"
          @update="update"
          @reset="reset"
        />
      </div>
      <div class="date-time">
        <div class="time-row">
          <span class="font">平日時段</span>
          <span class="font">{{normalDay}} 夜</span>
        </div>
        <div class="time-row">
          <span class="font">假日時段</span>
          <span class="font">{{hoilDay}} 夜</span>
        </div>
      </div>
      <div class="total">  <span>=</span> NT.{{total}}</div>
      <div class="button-row">
        <div @click="childClick" class="button cancel">取消</div>
        <div @click="isSuess=!isSuess;sentBooking()" class="button suess" :class="{isOK:!inputOK}">確定預約</div>
      </div>
      
    </div>
    <div class="booking-card" v-if="isSuess">
      <div class="title">預約成功</div>
      <div class="dec-box suess-dec">
        <span class="dec"></span>
        <span class="dec"></span>
        <span class="dec"></span>
      </div>
      <div class="img-box">
        <img :src="suessIcon">
      </div>
      <div class="button-row2">
        <router-link @click.native="childClick" to="/" class="button suess">回頁面</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import suessIcon from '../assets/icon2/circle.svg'
import VueHotelDatepicker from '@/components/VueHotelDatepicker.vue'
import axios from 'axios'

export default {
  name: 'booking',
  components: {
    VueHotelDatepicker
  },
  props: {
    currentRoomId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      childValue: false,
      isSuess: false,
      suessIcon: suessIcon,
      bookingInfo:{
        name:'',
        tel:'',
        date:[],
        roomId:''
      },
      normalDay: 0,
      hoilDay: 0
    }
  },
  computed:{
    disabledDates(){
      return this.$store.state.disabledDates
    },
    total(){
      let one = this.$store.state.room.normalDayPrice * this.normalDay
      let two = this.$store.state.room.holidayPrice * this.hoilDay
      return one + two
    },
    inputOK(){
      if(!this.bookingInfo.name)return false
      if(!this.bookingInfo.tel)return false
      if(this.bookingInfo.date.length<=0)return false
      this.bookingInfo.roomId = this.currentRoomId
      return true
    }
  },
  methods: {
      childClick () {
        this.$emit('childByValue', this.childValue)
      },
      confirm (confirm) {
        this.formatDate(confirm.start,confirm.end)
      },
      update (update) {
        if(update.start && update.end){
          this.formatDate(update.start,update.end)
        }
      },
      reset () {
        this.bookingInfo.date = []
        this.normalDay = 0
        this.hoilDay = 0
      },
      formatDate(x,y) {
        this.reset ()
        let days = this.DateDiff (x,y)

        this.bookingInfo.date.push(x)
        const xWeek = new Date(x).getDay()
        if(0<xWeek && xWeek<5){
          this.normalDay+=1
        }else{
          this.hoilDay +=1
        }

        let currentDate = x.replace(/\-/g,"/");
        let myDate = new Date(currentDate)
        for(let i=0; i<days; i++){
          let dayss = myDate.setDate(myDate.getDate() + 1)
          let day2 = new Date(dayss)
          let yyyy = day2.getFullYear()
          let MM = day2.getMonth()+1
          let dd = day2.getDate()
          let MMMM = '0'+MM
          let dddd = '0'+dd
          let result = yyyy + '-' + MMMM.slice(-2) + '-' + dddd.slice(-2)
          console.log(this.disabledDates)
          if(this.disabledDates.length>0){
            for(let p=0; p<this.disabledDates.length; p++){
              if(result===this.disabledDates[p]){
                break
              }else if(p===this.disabledDates.length-1){
                this.bookingInfo.date.push(result)
                const week = new Date(result).getDay()
                if(0<week && week<5){
                  this.normalDay+=1
                }else{
                  this.hoilDay +=1
                }
              }
            }
          }else{
            this.bookingInfo.date.push(result)
            const week = new Date(result).getDay()
            if(0<week && week<5){
              this.normalDay+=1
            }else{
              this.hoilDay +=1
            }
          }
          
        }
      },
      DateDiff (sDate1,  sDate2) {    //日期相減
        var  aDate,  oDate1,  oDate2,  iDays   //sDate1和sDate2是2002-12-18格式  
        aDate  =  sDate1.split("-")  
        oDate1  =  new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])    //轉換為12-18-2002格式  
        aDate  =  sDate2.split("-")  
        oDate2  =  new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])  
        iDays  =  parseInt(Math.abs(oDate1  -  oDate2)  /  1000  /  60  /  60  /24)    //把相差的毫秒數轉換為天數  
        return  iDays  
      },
      sentBooking(){
        this.$store.dispatch("bookingRoom",{ info:this.bookingInfo })
      }
    }
  }
</script>

<style scoped lang="scss" scoped>
  input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {
    -webkit-appearance: none ;
    appearance: none;
  }

  .booking{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index: 20;
    .booking-card{
      position: absolute;
      width: 425px;
      // height: 485px;
      background-color: #fff;
      top: 70%;
      left: 50%;
      transform: translate(-50%,-50%);
      padding: 27px 42px 34px 42px;
      .title{
        letter-spacing: 2px;
        font-weight: 500;
        font-size: 24px;
      }
      &.hiddenUp{
        opacity: 0;
        visibility: hidden;
      }
    }
  }
  .dec-box{
    margin-top: 0;
    margin-bottom: 45px;
  }
  .suess-dec{
    margin-bottom: 24px;
  }
  .input-row{
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .title-o{
      letter-spacing: 1px;
      font-size: 14px;
      font-weight: 500;
    }
    .input{
      width: 245px;
      height: 32px;
      border-radius: 5px;
      outline: none;
      border: 1px solid #C9C9C9;
      padding: 0 16px;
      font-size: 16px;
      // text-align: center;
    }
  }
  .date-time{
    position: absolute;
    margin-top: 15px;
    left: 0;
    width: 100%;
    background-color: #EDEDED;
    height: 70px;
    padding: 15px 42px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .time-row{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .font{
        color: #6D7278;
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
  .total{
    margin-top: 110px;
    letter-spacing: 2px;
    font-size: 26px;
    color: #FF5C5C;
    font-weight: 500;
    text-align: right;
    span{
      margin-right: 40px;
    }
  }
  .button-row{
    display: flex;
    margin-top: 30px;
    justify-content: space-between;
    width: 100%;
  }
  .button{
      display: inline-block;
      padding: 9px 24px;
      font-size: 14px;
      letter-spacing: 1px;
      font-weight: 500;
      cursor: pointer;
    }
    .cancel{
      background-color: #D8D8D8;
      color: #6D7278;
    }
    .suess{
      background-color: #484848;
      color: #fff;
      &.isOK{
        pointer-events: none;
        opacity: .5;
      }
    }
  .img-box{
    width: 100%;
    text-align: center;
    img{
      width: 60px;
      height: 60px;
    }
  }
  .button-row2{
    margin-top: 25px;
    width: 100%;
    text-align: right;
  }
</style>
